module.exports = __webpack_public_path__ + "media/application/images/typo_logo-dce5543e6dec40a63705dd47c6d239f2.png";